/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/common/money';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "rewards": {
                "nested": {
                  "RewardActivity": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "type": {
                        "type": ".squareup.corporate_card.resources.rewards.RewardActivity.Type",
                        "id": 2,
                        "rule": "optional"
                      },
                      "rewardPointsMoney": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "transactionAmountMoney": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 4,
                        "rule": "optional"
                      },
                      "createdAt": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "rewardMultiplier": {
                        "type": "int32",
                        "id": 6,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "rewardExpiresAt": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Type": {
                        "values": {
                          "TYPE_DO_NOT_USE": 0,
                          "REWARD_REDEMPTION": 1,
                          "REWARD_EARNED": 2,
                          "HACKWEEK_REWARD_CASHAPP_REDEMPTION": 3
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.RewardActivity && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.RewardActivity?.nested?.Type) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Information around redeemed free processing
 * --
 *
 * SOURCE RewardActivity @ squareup/corporate_card/resources/rewards/reward_activity.proto at 10:1
 */
export const RewardActivity = $root.lookupType('squareup.corporate_card.resources.rewards.RewardActivity');
fixType(RewardActivity);
Builder.createAndAttachToType(RewardActivity);
/**
 * SOURCE Type @ squareup/corporate_card/resources/rewards/reward_activity.proto at 11:3
 */
RewardActivity.Type = $root.lookupEnum('squareup.corporate_card.resources.rewards.RewardActivity.Type').values;